<template>
    <div class="coursesCard -type-1 pb-10 border-light bg-white rounded-8 mb-3 position-relative" data-aos="fade-up"
        :data-aos-delay="200" :style="{ opacity: loading ? '0.5' : '1' }" >
        <div @click="navigateToCourse(item?.slug)">
        <a v-if="item?.resume_link" :href="item?.resume_link">
            <div class="relative">
                <div class="coursesCard__image overflow-hidden rounded-8">
                    <div class="course-image-container">
                        <img class="w-1/1" :src="item?.preview_image[0]?.url" alt="image" />
                    </div>
                </div>
            </div>

            <div class="px-10 pt-10 d-flex flex-column gap-2 courseCard-body" style="flex:1 ; align-self: flex-end;">
                <h3 class="fw-700 text-dark-1 mt-15 capitalize">
                    {{ item?.title }}
                </h3>

                <div class="d-flex mt-10" v-if="item?.rating?.average_rating">
                    <div class="d-flex items-center">
                        <rating-component :rating="item?.rating?.average_rating" />
                    </div>
                </div>
                <div class="d-flex gap-3 teacher d-inline-flex align-items-center pb-10 x-gap-5">
                    <span class="d-inline-block">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                            <path
                                d="M1 15C1 13.9391 1.42143 12.9217 2.17157 12.1716C2.92172 11.4214 3.93913 11 5 11H13C14.0609 11 15.0783 11.4214 15.8284 12.1716C16.5786 12.9217 17 13.9391 17 15C17 15.5304 16.7893 16.0391 16.4142 16.4142C16.0391 16.7893 15.5304 17 15 17H3C2.46957 17 1.96086 16.7893 1.58579 16.4142C1.21071 16.0391 1 15.5304 1 15Z"
                                stroke="#94AD04" stroke-width="1.5" stroke-linejoin="round" />
                            <path
                                d="M9 7C10.6569 7 12 5.65685 12 4C12 2.34315 10.6569 1 9 1C7.34315 1 6 2.34315 6 4C6 5.65685 7.34315 7 9 7Z"
                                stroke="#94AD04" stroke-width="1.5" />
                        </svg>
                    </span>
                    <span class="fw-500 d-inline-block pt-1">{{ item?.author }}</span>
                </div>

                <div class="d-flex gap-3  d-inline-flex align-items-center py-10">
                    <span class="d-inline-block bold text-dark">
                        {{ $t('expires_in') }} :
                    </span>
                    <span class="fw-bold d-inline-block pt-1 text-dark">{{ item?.expire_at }}</span>
                </div>

                <div class="mt-10 progress-container">
                    <div class="d-inline-flex gap-2 mb-10">
                        <span class="fw-bold mt-auto"> {{ item?.progress }} % </span> 
                        <!----<span class="fw-bold text-dark">
                            {{ $t('completedText') }} </span>-->
                    </div>
                    <div class="progress">
                        <div class="progress-bar " role="progressbar"
                            :style="{ width: item?.progress ? `${item.progress}%` : '0%' }" aria-valuenow="25"
                            aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                </div>

                <div class="d-flex gap-3 d-inline-flex align-items-center mt-12 course-level" v-if="showLevel">
                    <span class="d-inline-block fw-500 pt-1"> Expires in {{ item?.options['expire_in_months'] }}
                        month</span>
                </div>
            </div>
        </a>
        </div>

    </div>
</template>
<script>
import store from '@/store';
import RatingComponent from './RatingComponent.vue';
export default {
    components: { RatingComponent },
    props: {
        showPrice: {
            type: Boolean,
            default: false,
        },
        showLevel: {
            type: Boolean,
            default: false,
        },
        item: {
            type: Object
        }
    },
    data() {
        return {
            loading: false
        }
    },
    computed: {
        isAuthenticated() {
            return store.getters.isAuthenticated
        },

    },
    methods: {
        async navigateToCourse(slug) {
            if (slug) {
                this.loading = true;
                await this.$router.push({ name: 'single-course', params: { id: slug } });
                this.loading = false;
            }
        }
    }
};
</script>
<style lang="scss" scoped>
/* HTML: <div class="loader"></div> */
.loader {
    width: 40px;
    aspect-ratio: 4;
    background: radial-gradient(circle closest-side, #09445d 90%, #0000) 0/calc(100%/3) 100% space;
    clip-path: inset(0 100% 0 0);
    animation: l1 1s steps(4) infinite;
}

.loader-container {
    top: 50%;
    left: 50%;
}

.progress-bar {
    background: #94ad04;
}

.progress,
.progress-stacked {
    height: 10px;
}

.progress-container {
    span:nth-of-type(1) {
        color: #94ad04;
    }

    &:lang(en) {
        text-align: right;
    }

    &:lang(ar) {
        text-align: left;
    }
}

@keyframes l1 {
    to {
        clip-path: inset(0 -34% 0 0)
    }
}
</style>